import React from 'react';
import RemoteSelect from 'common/components/RemoteSelect/RemoteSelect';
import TranslatedText from 'common/components/TranslatedText/TranslatedText';

const processOptions = (options) => options.map(({ id, name }) => (
  { value: id, label: <TranslatedText value={name} /> }
));

const ProductSelect = (props) => (
  <RemoteSelect
    filters={['id_ne']}
    url="products"
    processOptions={processOptions}
    {...props}
  />
);

export default ProductSelect;
